import { Institution, Company, Tag, TagType } from "solostar-graphql";

export const isUrmOrg = (org?: Institution | Company | null) =>
  org?.tags?.some(isUrmTag) || false;

export const isUrmTag = (tag: Tag) => tag.type === TagType.URM;
